module.exports = __webpack_public_path__ + "img/btn1.4a94a989.png";